<template>
  <div
    @click="selected"
    class="multimedia__content-document"
    role="button">
    <div class="multimedia__content-document-icon">
      <div class="multimedia__content-document-icon-text">{{ extension }}</div>
      <document-icon/>
    </div>
    <div class="multimedia__content-document-information">
      <div class="multimedia__content-document-text">{{ name }}</div>
      <div
        class="multimedia__content-document-text multimedia__content-document-text--subtitle">
        {{ size | filesize }}
      </div>
    </div>
  </div>
</template>

<script>
import DocumentIcon from '@/assets/icons/document.svg';

export default {
  components: {
    DocumentIcon,
  },
  props: {
    document: {
      required: true,
      type: Object,
    },
  },
  computed: {
    documentData() {
      return this.data ?? {};
    },
    name() {
      return this.documentData.filename ?? 'file';
    },
    extension() {
      return this.documentData.ext ?? '';
    },
    size() {
      return Number.parseInt(this.documentData.size ?? 0, 10);
    },
    data() {
      return this.document.document ?? this.document.multimedia;
    },
  },
  methods: {
    selected() {
      this.$emit('selected', this.document);
    },
  },
};
</script>
